const templates =  {
    "shop.okraina.ru": {
        title: "Регистрация",
        tags: [
        ]
    },
    "dostavka.okraina.ru": {
        title: "Регистрация",
        tags: [

        ]
    },
}

export default templates;